<div *ngIf="!badgeAssignments.length">{{ "delete_badge_ok" | localize }}</div>

<ng-container *ngIf="badgeAssignments.length">
  <div>{{ "delete_badge_warn" | localize }}</div>
  <badge-award-list [assignments]="badgeAssignments" />
</ng-container>
